import { Collection, Div, RefString, Snack } from "@tblabs/truffle";
import { CenteredLoader } from "../../../Components/Utils/CenteredLoader";
import { OrdersManager } from "../../../Services/OrdersManager";
import { Router } from "../../../Services/Router";
import { Center } from "../../../Components/Utils/Center";
import { HumanEdit } from "./Components/HumanEdit";
import { StepsEdit } from "./Components/StepsEdit";
import { StepFactory } from "../../../Services/StepFactory";
import { BasketItem } from "../../../Models/Basket/BasketItem";
import { StepType } from "../../../Steps/Step/StepType";
import { AddToBasketStep } from "../../../Steps/AddToBasket/AddToBasketStep";
import { SpecteamShopContentProvider } from "../../../Services/SpecteamShopContentProvider";
import { BasketEdit } from "./Components/BasketEdit";
import { InfoFrame } from "../../../Components/Utils/InfoFrame";
import { TabsV2 } from "../../../Components/Utils/Tabs";
import { Icons } from "../../../Components/Utils/Icons";
import { OrderEditHeader } from "./Components/OrderEditHeader";
import { OrderNotesEdit } from "../OrdersView/Views/Table/Components/OrderNotesEdit";


export class AdminOrderEditPage extends Div
{
    private loader = new CenteredLoader("Pobieranie zamówienia... Proszę czekać");

    constructor(
        private _manager: OrdersManager,
        private _router: Router,
        private _factory: StepFactory,
        private _shop: SpecteamShopContentProvider,
        private orderId: string)
    {
        super();

        this.Append(
            this.loader
        );
    }

    protected async OnAppend(): Promise<void>
    {
        try
        {
            const order = await this._manager.GetOne(this.orderId);

            this.loader.RemoveSelf();

            if (!order)
            {
                this.Append(new Center(`😥 Nie znaleziono zamówienia #${this.orderId?.toUpperCase()}\nJego adres jest niepoprawny albo zostało zamknięte lub usunięte.`).MarginTop(32))
                return;
            }

            const basketItems: AddToBasketStep[] = order.Steps.Filter(x => x.Type === StepType.AddToBasket) as AddToBasketStep[];
            const basket = new Collection<BasketItem>(basketItems.map(x => x.Data.BasketItems.Items).flat());

            const shop = await this._shop.Get();

            const view = new RefString("Koszyk").Storable("admin-order-edit-tab");
            const tabs = new TabsV2(view)
                .Add(Icons.Basket, "Koszyk", () => new BasketEdit(shop.Products, basket))
                .Add(Icons.Route, "Przebieg", () => new StepsEdit(this._factory, shop.Products, order))
                .Add(Icons.User, "Ludzie", () => new HumanEdit(order.People))
                .Add(Icons.Notes, "Notatki", () => new OrderNotesEdit(order))

            this.Append(
                new OrderEditHeader(this._router, this._manager, order),
                tabs)
        }
        catch (ex: any)
        {
            console.error(ex);
            new Snack(`❌ Problem: ${ex.message}`);
            this.Append(new InfoFrame(`Problem`, `${ex.message}`));
        }
    }
}
